import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { LoadingMessage } from "../../../odc-ui";
import { Frame } from "@bitesite/react-figstrap";
import { selectionButtonType } from "./utilities";
import ErrorText from "./error_text";
import { Button } from "../../../odc-ui";
import styled from "styled-components/macro";

const ProductSelection = ({
  purchaseMode,
  treatmentCategory,
  subscriptionPlan,
  selectedProduct,
  onProductClick,
  theme,
}) => {
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [products, setProducts] = useState();

  let ProductButton;
  let ProductButtonContainer;
  if (purchaseMode === "prepaid") {
    ProductButton = styled(Button)`
      text-transform: none;
      width: 170px;
    `;
    ProductButtonContainer = styled.div`
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 20px;
    `;
  } else if (purchaseMode === "auto_grow") {
    ProductButton = styled(Button)`
      text-transform: none;
      width: 100%;
    `;
    ProductButtonContainer = styled.div`
      display: flex;
      gap: 10px;
      flex-direction: column;
    `;
  }

  const loadProducts = () => {
    setLoadingProducts(true);

    let data;
    if (purchaseMode === "prepaid") {
      data = {
        purchase_mode: "prepaid",
        treatment_category: treatmentCategory,
      };
    } else if (purchaseMode === "auto_grow") {
      data = {
        square_subscription_plan_id: subscriptionPlan.id,
        treatment_category: treatmentCategory,
      };
    }

    $.getJSON("/products", data)
      .done((results) => {
        setProducts(results);
        setLoadingProducts(false);
      })
      .fail(() => {
        window.alert(
          "We're sorry, but we couldn't load the fund denominations."
        );
      });
  };

  useEffect(() => {
    if (
      (purchaseMode === "prepaid" && treatmentCategory) ||
      (purchaseMode === "auto_grow" && treatmentCategory && subscriptionPlan)
    ) {
      loadProducts();
    }
  }, [treatmentCategory, subscriptionPlan]);

  return (
    <Frame vertical gap={10}>
      <div>Select Amount</div>
      <div>
        {loadingProducts ? (
          <LoadingMessage message="Loading amounts..." />
        ) : (
          <>
            {products.length === 0 ? (
              <>
                {purchaseMode === "auto_grow" && (
                  <ErrorText>
                    We&apos;re still in the process of setting up this plan.
                    Please check back later.
                  </ErrorText>
                )}
                {purchaseMode === "prepaid" && (
                  <ErrorText>
                    We're sorry, but prepaid amounts are not available for
                    purchase at this time.
                  </ErrorText>
                )}
              </>
            ) : (
              <ProductButtonContainer>
                {products.map((product) => (
                  <div key={product.id}>
                    <ProductButton
                      href="#"
                      key={product.id}
                      onClick={(e) => {
                        e.preventDefault();
                        onProductClick(product);
                      }}
                      type={selectionButtonType(
                        theme,
                        selectedProduct && selectedProduct.id === product.id
                      )}
                    >
                      {product.name}
                    </ProductButton>
                  </div>
                ))}
              </ProductButtonContainer>
            )}
          </>
        )}
      </div>
    </Frame>
  );
};

ProductSelection.propTypes = {
  purchaseMode: PropTypes.string.isRequired,
  treatmentCategory: PropTypes.string.isRequired,
  subscriptionPlan: PropTypes.object.isRequired,
  selectedProduct: PropTypes.object,
  onProductClick: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

export default ProductSelection;
